import { createI18n, type I18nOptions } from 'vue-i18n'
import de from './de.json'
import datetimeFormats from './datetimeFormats'

type I18nSchema = typeof I18nOptions

const I18nOptions: I18nOptions = {
  availableLocales: ['de', 'fr', ' en'],
  locale: 'de',
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE as string,
  datetimeFormats: datetimeFormats(),
  globalInjection: true, // still allows to access $t in setup/templates directly.
  legacy: false,
  inheritLocale: true,
  formatFallbackMessages: true,
  messages: {
    de: de,
  },
}

const i18n = createI18n<false, I18nSchema>(I18nOptions)

export default i18n
